/**
 * Centralized theme configuration
 *
 * This file defines all colors, gradients, and styling tokens used across the app.
 * Uses DaisyUI theme system where possible for consistency.
 */

/**
 * Agent card color configurations
 * Each agent gets assigned a color from this palette in rotation
 */
export const agentCardColors = [
  // Uses DaisyUI semantic colors
  'btn-primary',     // Primary theme color
  'btn-secondary',   // Secondary theme color
  'btn-accent',      // Accent theme color
  'btn-info',        // Info color
  'btn-success',     // Success color
  'btn-warning',     // Warning color
  'btn-error',       // Error color
] as const;

/**
 * Page background gradient configuration
 * Light and dark mode variants
 */
export const pageGradients = {
  light: 'bg-gradient-to-br from-purple-50 via-blue-50 to-pink-50',
  dark: 'dark:bg-gradient-to-br dark:from-slate-900 dark:via-purple-900/20 dark:to-slate-900',
  combined: 'bg-gradient-to-br from-purple-50 via-blue-50 to-pink-50 dark:bg-gradient-to-br dark:from-slate-900 dark:via-purple-900/20 dark:to-slate-900'
} as const;

/**
 * Decorative blob gradients for background
 */
export const decorativeBlobs = {
  topRight: {
    light: 'bg-gradient-to-br from-purple-300/20 to-blue-300/20',
    dark: 'dark:from-purple-600/30 dark:to-blue-600/30',
  },
  bottomLeft: {
    light: 'bg-gradient-to-br from-pink-300/20 to-purple-300/20',
    dark: 'dark:from-pink-600/30 dark:to-purple-600/30',
  }
} as const;

/**
 * Text gradient for headings
 */
export const headingGradient = {
  light: 'from-purple-600 via-blue-600 to-pink-600',
  dark: 'dark:from-purple-400 dark:via-blue-400 dark:to-pink-400',
  combined: 'bg-gradient-to-r from-purple-600 via-blue-600 to-pink-600 dark:from-purple-400 dark:via-blue-400 dark:to-pink-400 bg-clip-text text-transparent'
} as const;

/**
 * Get agent card color class by index
 */
export function getAgentCardColor(index: number): string {
  return agentCardColors[index % agentCardColors.length];
}
